<template>
    <div>
        <b-card
                :img-src="gift.gift_image"
                :title="gift.gift_title">
            <p>score : {{gift.gift_score}}</p>
        </b-card>
    </div>
</template>

<script>
    export default {
        name: "Gift",
        props: {
            gift: {
                type: Object,
                default: null
            }
        }
    }
</script>

<style scoped>

</style>